export const SECOND_LOAN_PERCENT = "1";
export const SECOND_LOAN_AMOUNT = "2";

export default Object.freeze({
  [SECOND_LOAN_PERCENT]: "Percent",
  [SECOND_LOAN_AMOUNT]: "Amount"
});
